import LocalizedStrings from 'react-localization';
import { PaginationLocEN } from './PaginationLocEN';

export default new LocalizedStrings({
  en: {
    paginationComponent: PaginationLocEN('Page', 'out of')
  }
});
